import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "settings-row" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Metadata key", -1)
const _hoisted_3 = {
  key: 0,
  class: "settings-row"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "label" }, "New value", -1)
const _hoisted_5 = { class: "settings-row" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Delete value", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" This action changes to value of ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(". You can use metadata anywhere in the GUI where you could also use placeholders. Especially in placeholder-checks to check the value of metadata. Make sure to read the wiki for more information on how to work with metadata. ")

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives(_createVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.action.key = $event))
      }, null, 512), [
        [_vModelText, _ctx.action.key]
      ])
    ]),
    (_ctx.action.value !== undefined)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _hoisted_4,
          _withDirectives(_createVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.action.value = $event))
          }, null, 512), [
            [_vModelText, _ctx.action.value]
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_5, [
      _hoisted_6,
      _createVNode("input", {
        type: "checkbox",
        checked: _ctx.action.value === undefined,
        onChange: _cache[3] || (_cache[3] = $event => (_ctx.action.value = _ctx.action.value === undefined ? '' : undefined))
      }, null, 40, ["checked"])
    ]),
    _hoisted_7,
    _createVNode("p", null, [
      _hoisted_8,
      _createVNode("i", null, "%meta." + _toDisplayString(_ctx.action.key) + "%", 1),
      _hoisted_9
    ])
  ]))
}